module.exports = __webpack_public_path__ + "img/b3Code.3166f864.png";